module.exports = __webpack_public_path__ + "static/img/menpiao.5bd130f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menpiao.png
// module id = 53ug
// module chunks = 0